import type { Employee } from '../types/hr';
import { getHRState } from './hrStore';

export function getEmployee(id?: string): Employee | undefined {
  if (!id) return undefined;
  return getHRState().employees.find((e) => e.id === id);
}

export function displayName(employee: Employee): string {
  return `${employee.preferredName || employee.firstName} ${employee.lastName}`;
}

export function nameById(id?: string): string {
  const e = getEmployee(id);
  return e ? displayName(e) : '—';
}

export function directReports(id: string): Employee[] {
  return getHRState().employees.filter((e) => e.managerId === id && e.status !== 'Terminated');
}
